import axios from "../api/axiosInstance";

export const GetAllSetting = async () => {
    return await axios.get("/Setting/GetSettingList");
};

export const GetSettingById = async (id) => {
    return await axios.get("/Setting/GetSettingById", {
        params: { id }
    });
};

export const GetSettingByKey = async (key) => {
    return await axios.get("/Setting/GetSettingByKey", {
        params: { key }
    });
};

export const AddSetting = async (model) => {
    return await axios.post("/Setting/AddSetting", model);
};

export const UpdateSetting = async (model) => {
    return await axios.post("/Setting/UpdateSetting", model);
};

export const RemoveSetting = async (id) => {
    return await axios.post("/Setting/RemoveSetting", null, {
        params: { id }
    });
};